function FailMobileDiv(props) {
    return (
      <>
        <div className={props.class}>
            <p>如遇以下特殊情況或許未能成功完成預購訂單：</p>
            <ul>
                <li>號碼格式錯誤、香港手機號碼非8位及首位字符不是 4、5、6、7、8、9號碼字頭或長度不正確(如：固網電話號碼)</li>    
            </ul>
        </div>
      </>
    );
  }
  
export default FailMobileDiv;